import { IResourcePlannerColumn } from '@legacy/apis/types/resourcePlannerAPI';

export const TAKE = 50;

export const FIXED_COLUMNS: IResourcePlannerColumn[] = [
  {
    identifier: 'status',
    size: 100,
  },
  {
    alignment: 'center',
    format: 'date',
    identifier: 'startsAt',
    size: 100,
  },
  {
    alignment: 'center',
    format: 'date',
    identifier: 'endsAt',
    size: 100,
  },
  {
    alignment: 'right',
    format: 'number',
    identifier: 'budget',
    size: 100,
  },
  {
    alignment: 'right',
    format: 'number',
    identifier: 'totalBooked',
    size: 100,
  },
  {
    alignment: 'right',
    format: 'number',
    identifier: 'totalActualWorkload',
    size: 100,
  },
  {
    alignment: 'right',
    format: 'number',
    identifier: 'notPlanned',
    size: 100,
  },
];
